//TODO: implement
import {connect} from "react-redux";
import BusinessCard from './BusinessCard';
import selectors from '../selectors';
import {closeCardModal} from '../actions';
const {getBusinessCard} = selectors;

const mapStateToProps = (state) => {
    return {
        cardConfig: getBusinessCard(state),
        cardUrl: state.app.url
    }
}

const mapDispatchToProps = (dispatch) => {
    return{
        closeModal: () => dispatch(closeCardModal())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(BusinessCard);

